import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

const FilterDropdown = ({ label, value, options, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedOption = options.find((opt) => opt.value === value);

  return (
    <div className="ip-filter-dropdown" ref={ref}>
      <button
        type="button"
        className="ip-filter-dropdown-btn"
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className="ip-filter-dropdown-label">{label}</span>
        <span className="ip-filter-dropdown-sep">&middot;</span>
        <span className="ip-filter-dropdown-value">
          {selectedOption?.label || "All"}
        </span>
        <ChevronDown size={14} className="ip-filter-dropdown-chevron" />
      </button>

      {open && (
        <div className="ip-filter-dropdown-menu">
          {options.map((opt) => (
            <div
              key={opt.value}
              className={`ip-filter-dropdown-item ${
                opt.value === value ? "active" : ""
              }`}
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;
